import React from 'react';
import Dropzone from 'react-dropzone';
import { ImageCropModal } from '../ImageCropModal';

interface UploadDropzoneProps {
  maxSize?: number;
  aspectRatio?: number;
  onChange(file: File): void;
  onSizeError();
  onExtensionError();
}

interface UploadDropzoneState {
  image?: {
    fileName: string;
    dataUri: string;
  };
}

export class UploadDropzone extends React.Component<UploadDropzoneProps, UploadDropzoneState> {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleCancel = () => {
    this.setState({ image: undefined });
  };

  handleSave = (image) => {
    this.setState({ image: undefined });
    this.props.onChange(image);
  };

  handleFileDrop = async (files) => {
    const file = files[0];
    if (!file) {
      return;
    }

    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    if (!validImageTypes.includes(file.type)) {
      return this.props.onExtensionError();
    }

    if (this.props.maxSize && file.size / 1000 > this.props.maxSize) {
      return this.props.onSizeError();
    }

    if (this.props.aspectRatio) {
      this.setState({
        image: {
          dataUri: URL.createObjectURL(file),
          fileName: file.name,
        },
      });
    } else {
      this.props.onChange(files[0]);
    }
  };

  render() {
    return (
      <div>
        <Dropzone style={{}} onDrop={this.handleFileDrop}>
          {this.props.children}
        </Dropzone>
        {this.state.image && (
          <ImageCropModal
            aspectRatio={this.props.aspectRatio!}
            sourceUrl={this.state.image.dataUri}
            fileName={this.state.image.fileName}
            onCancel={this.handleCancel}
            onSave={this.handleSave}
          />
        )}
      </div>
    );
  }
}
